<template>
  <v-dialog v-model="show" fullscreen transition="dialog-bottom-transition" class="dialog">
    <template v-slot:default>
      <v-card class="d-flex flex-column">
        <v-card-title class="ml-4 mt-6 text-h4">Account Settings</v-card-title>
        <div class="mx-4">
          <v-list>
            <v-list-item>
              <span class="text-button" v-if="subscriptionActive">Current Plan:&nbsp;&nbsp;&nbsp;<span class="text-body-1 font-weight-bold">{{ subscriptionLevel }}</span></span>
              <span v-else>No Subscription</span>
              <v-btn size="medium" variant="text" class="ml-8" href="https://billing.stripe.com/p/login/bIYaI9awb43Oev64gg">Manage</v-btn> 
            </v-list-item>
            <!-- <v-list-item>
              https://billing.stripe.com/p/login/test_dR69DGbeag3eaUo000
              <v-text-field
                disabled
                label="Referral Code"
                v-model="userReferralCode"
                variant="outlined"
                class="mt-2" />
            </v-list-item> -->
            <!-- <v-list-item>
              <v-textarea
                label="Please add a description of your business or project here. You may also include relevant information like your role and business goals."
                v-model="context"
                variant="outlined"
                class="mt-2" />
            </v-list-item> -->
            <v-list-item v-if="isAdmin">
              <v-checkbox label="demo mode" v-model="demoMode"></v-checkbox>
            </v-list-item>
            <v-spacer></v-spacer>
            <v-list-item class="mt-8">
              <v-btn color="primary" @click="signOut">Sign Out</v-btn>
            </v-list-item>
            <v-list-item class="optionsBtns my-2">
              
            </v-list-item>
          </v-list>
        </div>
        <v-spacer></v-spacer>
        <v-card-actions>
          <!-- <v-btn size="x-large" color="primary" variant="text" @click="updateAccount(); show = false">
                <v-icon>mdi-check-bold</v-icon>
              </v-btn> -->
          
          <v-tooltip location="top">
            <template v-slot:activator="{ props: tooltip }">
              <v-btn v-bind="tooltip" size="x-large" color="secondary" variant="text" class="text-h4 close-btn" @click="show = false">
                <v-icon>mdi-close</v-icon>
                <!-- Close -->
              </v-btn>
            </template>
            <span>Close (esc)</span>
          </v-tooltip>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
<script lang="ts">
import { SubscriptionLocal } from '@/store'
import { Options, Vue } from 'vue-class-component'
import { mapGetters, mapState } from 'vuex'

@Options({
  computed: {
    ...mapState(['showOptions', 'userReferralCode', 'subscriptionInfo', 'isAdmin', 'demoModeDisplay']),
    ...mapGetters(['contextForUser'])
  },
  watch: {
    userContext(newVal: string) {
      this.context = newVal
    }
  }
})
export default class AccountDialog extends Vue {
  public isAdmin!: boolean
  public demoModeDisplay!: boolean
  public showOptions!: boolean
  public contextForUser!: string
  public context: string = ''
  public userReferralCode!: string
  public subscriptionInfo!: SubscriptionLocal

  created() {
    if (this.contextForUser) {
      this.context = this.contextForUser
    }
  }

  get show() {
    return this.showOptions
  }

  set show(value: boolean) {
    this.$store.dispatch('toggleOptions')
  }

  get demoMode() {
    return this.demoModeDisplay ?? false
  }

  set demoMode(value: boolean) {
    this.$store.dispatch('toggleDemoMode')
  }

  updateAccount() {
    const context = this.context.trim()
    if (context) {
      this.$store.dispatch('updateUserContext', { context })
    }
  }

  async signOut() {
    this.$store.dispatch('toggleOptions')
    await this.$store.dispatch('signOut')
  }

  get subscriptionActive() {
    if (this.subscriptionInfo == null) {
      return false
    }
    return this.subscriptionInfo.active
  }

  get subscriptionLevel() {
    if (this.subscriptionInfo == null) {
      return 'Trial'
    }
    return this.subscriptionInfo.level
  }

  get subscriptionEndDate() {
    if (this.subscriptionInfo == null) {
      return Date.now()
    }
    return this.subscriptionInfo.expires
  }
}
</script>
<style lang="scss" scoped>
.close-btn.v-btn--slim {
  min-width: 50px;
}
</style>